import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useUserProfile } from '../../api/profile';
import { prefetchOnboardingData } from './api';

/**
 * Component that prefetches onboarding data when user profile is loaded
 * This ensures the data is ready before the user navigates to onboarding
 */
export const OnboardingPrefetcher: React.FC = () => {
  const queryClient = useQueryClient();
  const { data: userProfile } = useUserProfile();

  React.useEffect(() => {
    // Only prefetch if user profile is loaded (user is authenticated)
    if (userProfile) {
      // Prefetch in the background - don't block on errors
      prefetchOnboardingData(queryClient).catch((error) => {
        // Silently fail - this is just prefetching for performance
        console.debug('Failed to prefetch onboarding data:', error);
      });
    }
  }, [userProfile, queryClient]);

  // This component doesn't render anything
  return null;
};
